import { I18n } from 'vue-i18n';
import {
    createMemoryHistory,
    createWebHistory,
    createRouter,
    Router,
} from 'vue-router';
import ContentIndexPage from '~/pages/content/Index.vue';
import PopupIndexPage from '~/pages/popup/Index.vue';
import SandboxPage from '~/pages/Sandbox.vue';
import SupportPage from '~/pages/support.vue';
import WelcomePage from '~/pages/welcome.vue';
import PwaIndexPage from '~/pages/pwa/Index.vue';
// import { appLanguages, setI18nLanguage } from './i18n';
// import { LanguageCode } from './types';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: PwaIndexPage,
        meta: {
            layout: 'AppLayoutContent',
        },
    },
    {
        path: '/content',
        name: 'Main',
        component: ContentIndexPage,
        meta: {
            layout: 'AppLayoutContent',
        },
    },
    {
        path: '/popup',
        name: 'Popup',
        component: PopupIndexPage,
        meta: {
            layout: 'AppLayoutContent',
        },
    },
    {
        path: '/sandbox',
        name: 'Sandbox',
        component: SandboxPage,
        meta: {
            layout: 'AppLayoutContent',
        },
    },
    {
        path: '/support',
        name: 'Support',
        component: SupportPage,
        meta: {
            layout: 'AppLayoutContent',
        },
    },
    {
        path: '/welcome',
        name: 'Welcome',
        component: WelcomePage,
        meta: {
            layout: 'AppLayoutContent',
        },
    },
];

export function setupRouter(i18n: I18n): Router {
    // const locale = getLocale(i18n);

    // Use web history for PWA, memory history for extension
    const isExtension =
        window.location.protocol === 'chrome-extension:' ||
        window.location.protocol === 'moz-extension:' ||
        window.location.protocol === 'safari-extension:' ||
        window.location.protocol === 'safari-web-extension:';

    const router = createRouter({
        history: isExtension ? createMemoryHistory() : createWebHistory(),
        routes,
    });

    // navigation guards
    // router.beforeEach(async (to) => {
    //     const url = new URL(window.location.href);
    //     const params = new URLSearchParams(url.search);

    //     let langDetected: LanguageCode = 'en';
    //     // 1) read theme from localstorage by default
    //     if (localStorage.getItem('lang')) {
    //         let l = localStorage.getItem('lang') as LanguageCode;
    //         if (appLanguages.find((item) => item.code === l)) {
    //             langDetected = l;
    //         }
    //     }
    //     // 2) get 'lang' parameter from window.location.search
    //     // read lang from URL `lang` parameter
    //     // NOTE: to.query.lang is not working here
    //     const langValue = params.get('lang') as LanguageCode;
    //     if (appLanguages.find((item) => item.code === langValue)) {
    //         langDetected = langValue;
    //     }

    //     // set i18n language
    //     setI18nLanguage(langDetected);
    // });

    return router;
}
